export const documentsPtBr = {
  common: {
    back: 'Voltar',
    save: 'Salvar',
    validate: 'Validar',
    reprocess: 'Reprocessar',
    saveChanges: 'Salvar Alterações',
    cancel: 'Cancelar',
    loading: 'Carregando...',
    loadingDocument: 'Carregando documento...',
    noData: 'Nenhum dado extraído disponível',
  },
  errors: {
    loadDocuments: 'Falha ao carregar documentos',
    loadEntities: 'Falha ao carregar entidades. Verifique se há uma entidade cadastrada.',
    noEntities:
      'Nenhuma entidade encontrada. Por favor, cadastre uma entidade antes de fazer upload de documentos.',
    loadDocument: 'Falha ao carregar documento',
    saveChanges: 'Falha ao salvar alterações',
    validate: 'Falha ao validar documento',
    reprocess: 'Falha ao reprocessar documento',
    upload: 'Falha ao enviar arquivos',
    uploadFiles: 'Falha ao enviar {{count}} arquivo(s): {{errors}}',
  },
  success: {
    saveChanges: 'Alterações salvas com sucesso!',
    validate: 'Documento validado com sucesso!',
    reprocess: 'Documento reenfileirado para processamento!',
    upload: '{{count}} arquivo(s) enviado(s) com sucesso!',
    uploadDuplicates: '{{count}} arquivo(s) duplicado(s) ignorado(s).',
  },
  processingWidget: {
    title: 'Processamento de documentos',
    queueEmpty: 'Fila vazia',
    inProgressCount: '{{count}} em andamento',
    failedCount: '{{count}} falhou',
    refreshStatus: 'Atualizar status',
    noProcessing: 'Nenhum documento em processamento nas últimas 24h',
    loadingProcessing: 'Carregando documentos em processamento...',
    completedSession: 'Concluídos nesta sessão',
    failedRecent: '{{count}} documento(s) com falhas nos últimos 7 dias',
    progress: 'Progresso',
    status: {
      pending: 'Pendente',
      processing: 'Processando',
      extracted: 'Extraído',
      pendingReview: 'Aguardando revisão',
      classifying: 'Classificando',
      completed: 'Concluído',
      reconciliationCompleted: 'Conciliação concluída',
    },
    completion: {
      linkedLabel: 'Documento vinculado',
      linkedDescription: 'Documento associado a uma conta existente.',
      createdLabel: 'Conta criada',
      createdDescription: 'Conta criada a partir do documento.',
      completedLabel: 'Processamento concluído',
      completedDescription: 'Documento processado com sucesso.',
      duplicateUploadLabel: 'Arquivo já enviado',
      duplicateUploadDescription:
        'Este documento já estava no sistema. Abra a conta existente para continuar.',
      duplicateUploadNoBillDescription:
        'Este documento já estava no sistema. A conta pode ainda estar sendo vinculada — tente abrir em instantes.',
      reimbursementRequestLabel: 'Pedido de reembolso criado',
      reimbursementRequestDescription:
        'Pedido de reembolso criado — a conta aparece após aprovação.',
      viewReimbursementRequest: 'Ver pedido de reembolso',
    },
    reimbursementAccessDenied: 'Você não tem permissão para visualizar este pedido de reembolso.',
    failedButton: 'Ver documentos com falhas',
    failedTitle: 'Documentos com falhas',
    failedDescription:
      'Revise os documentos que não foram processados e tente reenviar para a fila.',
    failedBadge: 'Falhou',
    retry: 'Tentar novamente',
    retrying: 'Reenviando...',
    retrySuccess: 'Documento reenviado para processamento',
    retryError: 'Não foi possível reenviar o documento',
    unprocessableDocumentTypeMessage:
      'Não foi possível identificar o tipo deste documento. Selecione o tipo manualmente para tentar novamente.',
    unreadableDocumentMessage:
      'Este documento parece estar corrompido ou ilegível. Tente enviar uma captura de tela (screenshot) ou uma versão mais nítida do documento.',
    documentTypeSelectLabel: 'Tipo do documento',
    documentTypeSelectPlaceholder: 'Selecione o tipo',
    addInstructionsLink: '(Opcional) Adicionar instruções',
    instructionsLabel: 'Instrucoes para processamento',
    instructionsPlaceholder:
      'Ex: Esta e uma conta de energia da CEMIG, a segunda pagina contem o boleto',
    documentTypeOptions: {
      BOLETO: 'Boleto',
      NFE_SERVICO: 'NF-e de serviço',
      NFE_PRODUTO: 'NF-e de produto',
      BOLETO_COM_NF: 'Boleto com nota fiscal',
      CARD_INVOICE: 'Fatura de cartão',
      INTERNATIONAL_INVOICE: 'Invoice internacional',
      TELECOM_BILL: 'Conta de telecom',
      UTILITIES_BILL: 'Conta de consumo',
      DARF: 'DARF',
      GPS: 'GPS',
      GUIA_ISS: 'Guia ISS',
      GUIA_ICMS: 'Guia ICMS',
      GRF: 'GRF',
      DAS: 'DAS',
      COMPROVANTE_PAGAMENTO: 'Comprovante de pagamento',
      CUPOM_FISCAL: 'Cupom fiscal',
      RECIBO_PLATAFORMA: 'Recibo de plataforma',
      RECIBO_GENERICO: 'Recibo genérico',
    },
    duplicateNfRetryDisabled: 'Documentos marcados como NF duplicada não podem ser reenviados.',
    viewDetails: 'Ver detalhes',
    viewBill: 'Ver conta',
    goToBill: 'Ir para a conta',
    duplicateNfWarning: 'Esta nota fiscal já foi recebida automaticamente via Focus NFe.',
    billNotReady: 'A conta ainda não está disponível. Tente novamente em instantes.',
    billFetchError: 'Não foi possível carregar a conta.',
    showMore: 'Ver mais',
    showLess: 'Mostrar menos',
    unknownError: 'Erro desconhecido',
    dismiss: 'Descartar',
    dismissing: 'Descartando...',
    dismissAll: 'Descartar todos',
    dismissAllTitle: 'Descartar documentos com falhas?',
    dismissAllDescription:
      'Esta ação removerá os documentos com falhas da lista e permitirá reenviá-los.',
    dismissConfirm: 'Descartar',
    dismissSuccess: '{{count}} documento(s) descartado(s)',
    dismissError: 'Não foi possível descartar os documentos',
    dismissSingleSuccess: 'Documento descartado',
    dismissSingleError: 'Não foi possível descartar o documento',
    dismissingAll: 'Descartando...',
    dismissFailures: 'Descartar falhas',
    dismissingFailures: 'Descartando falhas...',
    cancelProcessing: 'Cancelar processamento',
    cancelProcessingTitle: 'Cancelar processamento deste documento?',
    cancelProcessingDescription:
      'O arquivo será descartado e você poderá enviar outro. Um job já em execução no servidor pode terminar em seguida, mas o resultado não será aplicado a este envio.',
    cancelProcessingConfirm: 'Cancelar',
    cancelProcessingSuccess: 'Processamento cancelado. Você pode enviar o arquivo novamente.',
    cancelProcessingError: 'Não foi possível cancelar o processamento',
    cancelProcessingBusy: 'Cancelando...',
    longRunningProcessingHint:
      'Demorando demais? Você pode cancelar e tentar de novo — o envio atual será descartado.',
    requeueImport: 'Reenfileirar',
    requeueImportHint:
      'O extrato foi extraído, mas o worker pode não ter concluído. Reenfileire para criar as transações.',
    requeueSuccess: 'Importação reenfileirada. Aguarde o processamento.',
    requeueError: 'Não foi possível reenfileirar o import',
    importAllDuplicates: '{{total}} transações no arquivo. Todas já existiam (duplicatas).',
    importMixed: '{{new}} novas, {{dup}} duplicatas.',
    importAllNew: '{{count}} transações importadas.',
    importMissing: 'Importar transações faltantes',
    importMissingSuccess:
      'Extratos reenfileirados. Transações faltantes serão importadas em breve.',
    importMissingNoDocs: 'Nenhum extrato encontrado para reprocessar.',
    importMissingError: 'Erro ao reprocessar. Tente novamente.',
  },
  pages: {
    review: {
      tabs: {
        all: 'Todos',
        pending: 'Pendentes',
        processing: 'Processando',
        extracted: 'Extraídos',
        validated: 'Validados',
        failed: 'Falhas',
      },
      toolbar: {
        searchPlaceholder: 'Pesquisar documentos...',
        searchPlaceholderFile: 'Pesquisar por nome do arquivo...',
        statusFilter: 'Status',
        typeFilter: 'Tipo',
        all: 'Todos',
        status: {
          pending: 'Pendente',
          processing: 'Processando',
          extracted: 'Extraído',
          validated: 'Validado',
          failed: 'Falhado',
        },
        type: {
          boleto: 'Boleto',
          nfe: 'NF-e',
          genericInvoice: 'Nota Fiscal',
          unknown: 'Desconhecido',
        },
      },
      table: {
        file: 'Arquivo',
        type: 'Tipo',
        status: 'Status',
        vendor: 'Fornecedor',
        amount: 'Valor',
        dueDate: 'Vencimento',
        uploadDate: 'Data de Upload',
        actions: 'Ações',
        viewDetails: 'Ver Detalhes',
        loading: 'Carregando...',
        noDocuments: 'Nenhum documento encontrado.',
      },
      upload: {
        title: 'Enviar Documentos',
        description: 'Arraste arquivos aqui ou clique para selecionar',
        supportedFormats: 'Formatos suportados: PDF, PNG, JPG',
        maxSize: 'Tamanho máximo: 10MB',
      },
    },
    detail: {
      header: {
        official: 'OFFICIAL',
        ai: 'AI',
        officialSource: 'Dados 100% oficiais via {{provider}}',
        tabs: {
          parties: 'Partes',
          items: 'Itens',
          financial: 'Financeiro',
          document: 'Dados do Documento',
          official: 'Extração Oficial',
        },
      },
      parties: {
        vendor: 'Fornecedor',
        customer: 'Cliente',
        confidence: 'Confiança: {{value}}%',
      },
      items: {
        title: 'Item {{number}}',
        description: 'Descrição',
        quantity: 'Quantidade',
        unitPrice: 'Valor Unitário',
        netValue: 'Valor Líquido',
        noItems: 'Nenhum item encontrado',
      },
      financial: {
        grossAmount: 'Valor Bruto',
        discounts: 'Descontos',
        netAmount: 'Valor Líquido',
        taxes: 'Impostos',
        boletoData: {
          title: 'Dados do Boleto',
          digitavelLine: 'Linha Digitável',
          originalValue: 'Valor Original',
          finalValue: 'Valor Final',
          dueDate: 'Data de Vencimento',
        },
        nfeData: {
          title: 'Dados da NF-e',
          accessKey: 'Chave de Acesso',
          series: 'Série',
          number: 'Número',
        },
      },
      document: {
        documentType: 'Tipo de Documento',
        confidence: 'Confiança: {{value}}%',
        validations: {
          title: 'Validações',
        },
        qualityFlags: {
          title: 'Sinalizações de Qualidade',
          confidence: 'Confiança: {{value}}%',
        },
      },
      official: {
        status: {
          title: 'Status da Extração Oficial',
          success: 'Dados oficiais encontrados via {{provider}}',
        },
        nfe: {
          title: 'Dados Oficiais da NF-e',
          accessKey: 'Chave de Acesso',
          series: 'Série',
          number: 'Número',
        },
        boleto: {
          title: 'Dados Oficiais do Boleto',
          digitavelLine: 'Linha Digitável',
          finalValue: 'Valor Final',
          dueDate: 'Data de Vencimento',
        },
        divergences: {
          title: 'Divergências (IA vs Oficial)',
          description: 'Comparação entre dados extraídos por IA e dados oficiais',
          available:
            'Dados oficiais disponíveis para comparação. Divergências serão exibidas aqui quando implementadas.',
        },
      },
    },
  },
  providers: {
    officialApi: 'API oficial',
  },
  uploadArea: {
    dropTitle: 'Arraste arquivos aqui ou clique para selecionar',
    dropHint: 'Formatos suportados: PDF, PNG, JPG',
    dropHintWithCfdiXml: 'Formatos suportados: PDF, PNG, JPG, XML (CFDI)',
    dropHintWithMax: '{{hint}} (até {{max}} arquivos)',
    dropActive: 'Solte os arquivos aqui',
    selectFiles: 'Selecionar arquivos',
    takePhoto: 'Tirar foto',
    filesSelected: '{{count}} arquivo(s) selecionado(s)',
    retryAnalysis: 'Reanalisar',
    tryAnotherPhoto: 'Tentar outra foto',
    continueManually: 'Continuar e preencher manualmente',
    errors: {
      selectEntity: 'Selecione uma entidade para continuar',
      uploadUnavailable: 'Upload indisponível no momento',
      maxFiles: 'Máximo de {{max}} arquivos por envio',
    },
  },
} as const;

export const documentsEn = {
  common: {
    back: 'Back',
    save: 'Save',
    validate: 'Validate',
    reprocess: 'Reprocess',
    saveChanges: 'Save Changes',
    cancel: 'Cancel',
    loading: 'Loading...',
    loadingDocument: 'Loading document...',
    noData: 'No extracted data available',
  },
  errors: {
    loadDocuments: 'Failed to load documents',
    loadEntities: 'Failed to load entities. Check if there is a registered entity.',
    noEntities: 'No entities found. Please register an entity before uploading documents.',
    loadDocument: 'Failed to load document',
    saveChanges: 'Failed to save changes',
    validate: 'Failed to validate document',
    reprocess: 'Failed to reprocess document',
    upload: 'Failed to upload files',
    uploadFiles: 'Failed to upload {{count}} file(s): {{errors}}',
  },
  success: {
    saveChanges: 'Changes saved successfully!',
    validate: 'Document validated successfully!',
    reprocess: 'Document re-queued for processing!',
    upload: '{{count}} file(s) uploaded successfully!',
    uploadDuplicates: '{{count}} duplicate file(s) ignored.',
  },
  processingWidget: {
    title: 'Document processing',
    queueEmpty: 'Queue is empty',
    inProgressCount: '{{count}} in progress',
    failedCount: '{{count}} failed',
    refreshStatus: 'Refresh status',
    noProcessing: 'No documents processing in the last 24h',
    loadingProcessing: 'Loading documents in processing...',
    completedSession: 'Completed in this session',
    failedRecent: '{{count}} document(s) with failures in the last 7 days',
    progress: 'Progress',
    status: {
      pending: 'Pending',
      processing: 'Processing',
      extracted: 'Extracted',
      pendingReview: 'Pending review',
      classifying: 'Classifying',
      completed: 'Completed',
      reconciliationCompleted: 'Reconciliation completed',
    },
    completion: {
      linkedLabel: 'Document linked',
      linkedDescription: 'Document linked to an existing bill.',
      createdLabel: 'Bill created',
      createdDescription: 'Bill created from the document.',
      completedLabel: 'Processing completed',
      completedDescription: 'Document processed successfully.',
      duplicateUploadLabel: 'Already uploaded',
      duplicateUploadDescription:
        'This file was already in the system. Open the existing bill to continue.',
      duplicateUploadNoBillDescription:
        'This file was already in the system. The bill link may still be processing — try again shortly.',
      reimbursementRequestLabel: 'Reimbursement request created',
      reimbursementRequestDescription:
        'Reimbursement request created — the bill appears after approval.',
      viewReimbursementRequest: 'View reimbursement request',
    },
    reimbursementAccessDenied: 'You do not have permission to view this reimbursement request.',
    failedButton: 'View documents with failures',
    failedTitle: 'Documents with failures',
    failedDescription: 'Review documents that failed processing and retry them.',
    failedBadge: 'Failed',
    retry: 'Retry',
    retrying: 'Retrying...',
    retrySuccess: 'Document re-queued for processing',
    retryError: 'Unable to retry the document',
    unprocessableDocumentTypeMessage:
      'Unable to identify this document type. Select the type manually to retry processing.',
    unreadableDocumentMessage:
      'This document appears to be corrupted or unreadable. Try uploading a screenshot or a clearer version of the document.',
    documentTypeSelectLabel: 'Document type',
    documentTypeSelectPlaceholder: 'Select a type',
    addInstructionsLink: '(Optional) Add instructions',
    instructionsLabel: 'Processing instructions',
    instructionsPlaceholder: 'E.g.: This is a utility bill from CEMIG, page 2 has the payment slip',
    documentTypeOptions: {
      BOLETO: 'Boleto',
      NFE_SERVICO: 'Service invoice (NF-e)',
      NFE_PRODUTO: 'Product invoice (NF-e)',
      BOLETO_COM_NF: 'Boleto with invoice',
      CARD_INVOICE: 'Credit card statement',
      INTERNATIONAL_INVOICE: 'International invoice',
      TELECOM_BILL: 'Telecom bill',
      UTILITIES_BILL: 'Utilities bill',
      DARF: 'DARF',
      GPS: 'GPS',
      GUIA_ISS: 'ISS guide',
      GUIA_ICMS: 'ICMS guide',
      GRF: 'GRF',
      DAS: 'DAS',
      COMPROVANTE_PAGAMENTO: 'Payment receipt',
      CUPOM_FISCAL: 'Fiscal receipt',
      RECIBO_PLATAFORMA: 'Platform receipt',
      RECIBO_GENERICO: 'Generic receipt',
    },
    duplicateNfRetryDisabled: 'Documents marked as duplicate fiscal notes cannot be retried.',
    viewDetails: 'View details',
    viewBill: 'View bill',
    goToBill: 'Go to bill',
    duplicateNfWarning: 'This fiscal note was already received automatically via Focus NFe.',
    billNotReady: 'The bill is not available yet. Please try again in a moment.',
    billFetchError: 'Unable to load the bill.',
    showMore: 'Show more',
    showLess: 'Show less',
    unknownError: 'Unknown error',
    dismiss: 'Dismiss',
    dismissing: 'Dismissing...',
    dismissAll: 'Dismiss all',
    dismissAllTitle: 'Dismiss failed documents?',
    dismissAllDescription:
      'This action removes failed documents from the list and allows re-uploading them.',
    dismissConfirm: 'Dismiss',
    dismissSuccess: '{{count}} document(s) dismissed',
    dismissError: 'Unable to dismiss documents',
    dismissSingleSuccess: 'Document dismissed',
    dismissSingleError: 'Unable to dismiss the document',
    dismissingAll: 'Dismissing...',
    dismissFailures: 'Dismiss failures',
    dismissingFailures: 'Dismissing failures...',
    cancelProcessing: 'Cancel processing',
    cancelProcessingTitle: 'Cancel processing for this document?',
    cancelProcessingDescription:
      'The file will be discarded and you can upload again. A job already running on the server may still finish, but its result will not apply to this upload.',
    cancelProcessingConfirm: 'Cancel',
    cancelProcessingSuccess: 'Processing cancelled. You can upload the file again.',
    cancelProcessingError: 'Unable to cancel processing',
    cancelProcessingBusy: 'Cancelling...',
    longRunningProcessingHint:
      'Taking too long? You can cancel and try again — this upload will be discarded.',
    requeueImport: 'Re-enqueue',
    requeueImportHint: 'Re-enqueue import processing when stuck after extraction.',
    requeueSuccess: 'Import re-enqueued. Processing will resume shortly.',
    requeueError: 'Unable to re-enqueue import',
    importAllDuplicates: '{{total}} transactions in file. All already existed (duplicates).',
    importMixed: '{{new}} new, {{dup}} duplicates.',
    importAllNew: '{{count}} transactions imported.',
    importMissing: 'Import missing transactions',
    importMissingSuccess: 'Statements re-queued. Missing transactions will be imported shortly.',
    importMissingNoDocs: 'No statements found to reprocess.',
    importMissingError: 'Error reprocessing. Please try again.',
  },
  pages: {
    review: {
      tabs: {
        all: 'All',
        pending: 'Pending',
        processing: 'Processing',
        extracted: 'Extracted',
        validated: 'Validated',
        failed: 'Failed',
      },
      toolbar: {
        searchPlaceholder: 'Search documents...',
        searchPlaceholderFile: 'Search by file name...',
        statusFilter: 'Status',
        typeFilter: 'Type',
        all: 'All',
        status: {
          pending: 'Pending',
          processing: 'Processing',
          extracted: 'Extracted',
          validated: 'Validated',
          failed: 'Failed',
        },
        type: {
          boleto: 'Boleto',
          nfe: 'NFe',
          genericInvoice: 'Invoice',
          unknown: 'Unknown',
        },
      },
      table: {
        file: 'File',
        type: 'Type',
        status: 'Status',
        vendor: 'Vendor',
        amount: 'Amount',
        dueDate: 'Due Date',
        uploadDate: 'Upload Date',
        actions: 'Actions',
        viewDetails: 'View Details',
        loading: 'Loading...',
        noDocuments: 'No documents found.',
      },
      upload: {
        title: 'Upload Documents',
        description: 'Drag files here or click to select',
        supportedFormats: 'Supported formats: PDF, PNG, JPG',
        maxSize: 'Max size: 10MB',
      },
    },
    detail: {
      header: {
        official: 'OFFICIAL',
        ai: 'AI',
        officialSource: '100% official data via {{provider}}',
        tabs: {
          parties: 'Parties',
          items: 'Items',
          financial: 'Financial',
          document: 'Document Data',
          official: 'Official Extraction',
        },
      },
      parties: {
        vendor: 'Vendor',
        customer: 'Customer',
        confidence: 'Confidence: {{value}}%',
      },
      items: {
        title: 'Item {{number}}',
        description: 'Description',
        quantity: 'Quantity',
        unitPrice: 'Unit Price',
        netValue: 'Net Value',
        noItems: 'No items found',
      },
      financial: {
        grossAmount: 'Gross Amount',
        discounts: 'Discounts',
        netAmount: 'Net Amount',
        taxes: 'Taxes',
        boletoData: {
          title: 'Boleto Data',
          digitavelLine: 'Digitável Line',
          originalValue: 'Original Value',
          finalValue: 'Final Value',
          dueDate: 'Due Date',
        },
        nfeData: {
          title: 'NFe Data',
          accessKey: 'Access Key',
          series: 'Series',
          number: 'Number',
        },
      },
      document: {
        documentType: 'Document Type',
        confidence: 'Confidence: {{value}}%',
        validations: {
          title: 'Validations',
        },
        qualityFlags: {
          title: 'Quality Flags',
          confidence: 'Confidence: {{value}}%',
        },
      },
      official: {
        status: {
          title: 'Official Extraction Status',
          success: 'Official data found via {{provider}}',
        },
        nfe: {
          title: 'Official NFe Data',
          accessKey: 'Access Key',
          series: 'Series',
          number: 'Number',
        },
        boleto: {
          title: 'Official Boleto Data',
          digitavelLine: 'Digitável Line',
          finalValue: 'Final Value',
          dueDate: 'Due Date',
        },
        divergences: {
          title: 'Divergences (AI vs Official)',
          description: 'Comparison between AI-extracted data and official data',
          available:
            'Official data available for comparison. Divergences will be displayed here when implemented.',
        },
      },
    },
  },
  providers: {
    officialApi: 'Official API',
  },
  uploadArea: {
    dropTitle: 'Drag files here or click to select',
    dropHint: 'Supported formats: PDF, PNG, JPG',
    dropHintWithCfdiXml: 'Supported formats: PDF, PNG, JPG, XML (CFDI)',
    dropHintWithMax: '{{hint}} (up to {{max}} files)',
    dropActive: 'Drop files here',
    selectFiles: 'Select files',
    takePhoto: 'Take photo',
    filesSelected: '{{count}} file(s) selected',
    retryAnalysis: 'Reanalyze',
    tryAnotherPhoto: 'Try another photo',
    continueManually: 'Continue and fill in manually',
    errors: {
      selectEntity: 'Select an entity to continue',
      uploadUnavailable: 'Upload is unavailable right now',
      maxFiles: 'Maximum of {{max}} files per upload',
    },
  },
} as const;
